const randomInteger = () => {
  return Math.floor(Math.random() * 10000000000000);
};

export default randomInteger;
